// Generated with util/create-component.js
import React from 'react'
import Icon from '../Icon/Icon'
import { CardProps } from './Card.types'

const Card: React.FC<CardProps> = ({
    style = {},
    titleStyle = {},
    contentStyle = {},
    icon = null,
    iconStyle = {},
    iconSpin = false,
    noIcon,
    titleSize = 'sm',
    type = 'info',
    children,
    show = true,
    title,
}) => {
    if (!show) {
        return null
    }

    const classNames = () => {
        const c = ['r-card-wrapper', `r-state-${type}`]

        switch (titleSize) {
            case 'sm':
                c.push('r-title-size-sm')
                break
            case 'lg':
                c.push('r-title-size-lg')
                break
        }

        return c.join(' ')
    }

    const renderIcon = () => {
        let _icon

        if (noIcon) {
            return null
        }

        if (type === 'info') {
            _icon = 'info-circle'
        }
        if (type === 'danger') {
            _icon = 'exclamation-circle'
        }
        if (type === 'success') {
            _icon = 'check-circle'
        }
        if (type === 'warning') {
            _icon = 'minus-circle'
        }
        if (icon) {
            _icon = icon
        }

        if (_icon) {
            return (
                <div className={'r-card-icon'} style={iconStyle}>
                    <Icon spin={iconSpin} style={{ padding: 0 }} type={_icon} />
                </div>
            )
        }
        return null
    }

    return (
        <div data-testid='Card' className={classNames()} style={style}>
            {renderIcon()}
            <div className={'r-card-contents'} style={contentStyle}>
                {title ? (
                    <div className='r-card-title' style={titleStyle}>
                        {title}
                    </div>
                ) : (
                    ''
                )}
                <div data-testid='Card' className='r-card'>
                    {children}
                </div>
            </div>
        </div>
    )
}
export default Card
